import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCMG5QyS1HSW3PTbFq5KoFpSZ1hg7dGMTI",
  authDomain: "platforms-tech.firebaseapp.com",
  projectId: "platforms-tech",
  storageBucket: "platforms-tech.appspot.com",
  messagingSenderId: "117841179661",
  appId: "1:117841179661:web:6abe86167015d99e11d144",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore. Unset → `(default)` (prod data); client-dev builds with
// REACT_APP_FIRESTORE_DATABASE_ID=orion-dev to read the isolated dev database.
const firestoreDatabaseId = process.env.REACT_APP_FIRESTORE_DATABASE_ID?.trim();
export const db = firestoreDatabaseId
  ? getFirestore(app, firestoreDatabaseId)
  : getFirestore(app);

export default app;
